import { AsyncAjaxGet, AsyncAjaxPost } from "components/Common/AsyncAjaxService"
import useGenerateToken from "components/Hook/useGenerateToken"
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useRef, useState } from "react"
import { Form } from "react-bootstrap"
import { ResponseCode, utils, VagaroAPIURL } from "utils/Utils"
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext"
import './MultilocationDiv.scss'
import { DownCaret, RightCaret } from "components/WebDesigner/Icons/Carets"
import { CategorySelector, CheckCategory } from "components/WebDesigner/StyleInputs/CategorySelector"
import store from "app/store"
import VGPopUp from "components/Controls/VGPopUp"
import ReactDOM, { createPortal, unmountComponentAtNode } from "react-dom"
import Toast from "components/WebDesigner/Toast"
import { UpdateLocationCount } from "components/Slice/Business"
import { SearchIcon } from "components/WebDesigner/SelectDropdown"
import WebDesigner from "components/WebDesigner/WebDesigner"
import { DefaultSiteData } from "components/WebDesigner/Data/SiteData"
type MultiLocationGroup = {
    groupName: string,
    groupData: MultiLocationData[]


}

type PlanBracket = {
    fromPlan: number,
    toPlan: number,
    charges: number,
    isContactSales: boolean,
}



type MultiLocationData = {
    alias: string,
    businessName: string,
    cdn: string,
    city: string,
    countryID: number,
    domain: string,
    isDefault: boolean,
    isPromoBusiness: boolean,
    isSelected: boolean,
    merchantId: string,
    nickName: string,
    stateCode: string,
    stateName: string,
    street: string,
    urlAddress: string,
    urlName: string,
    urlType: number,
    vagaroURL: string,
    zip: string,
    groupName: string

}


export default function MultiLocationMenu({ designer, userContext, dispatch, onClose, onCancel }: { designer?: WebDesigner, onClose: () => void,onCancel: () => void, userContext: UserContext, dispatch?: any }) {

    const { CurrencySymbol, IsModifyAllowed, CountryID } = store.getState().Business;
    const [catFilterItems, setCatFilterItems] = useState<CheckCategory[]>([]);
    const [numSelectedLocations, setNumSelectedLocations] = useState<number>(0);
    const [totalNumOfLocations, setTotalNumOfLocations] = useState<number>(0);
    const [isStencilded, setIsStenciled] = useState<boolean>(true);
    const [locationGroups, setLocationGroups] = useState<MultiLocationGroup[]>([]);
    const [planData, setPlanData] = useState<PlanBracket[]>([]);
    const [filter, setFilter] = useState<string>("");
    const loadSuccessRef = useRef<number>(0);

    const getMultiLocationSuccess = (data: any) => {

        let multiData = data?.data?.data;
        if (multiData) {

            let merchantMapping = multiData?.merchantMapping as MultiLocationData[] || [];
            let groups: MultiLocationGroup[] = [];
            let checkGroups: CheckCategory[] = [];

            let isPromoCodeBusiness = multiData.isPromoCodeBusiness || false;



            //loop through all businesses and create groups if they don't exist.
            //one group for rendering table and another for handling the check selections
            for (let i = 0; i < merchantMapping.length; i++) {
                let d = merchantMapping[i];
                //if the cdn is empty, use the default image
                if (!d.cdn || d.cdn.endsWith("Compressed/")) {
                    d.cdn = "https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc0dc7308f897.ssl.cf2.rackcdn.com/Websitebuilder/20241205214728.png";
                }
                let groupName = isPromoCodeBusiness ? d.stateName : (d.groupName || "")
                let findGroup = groups.find(g => g.groupName === groupName);
                let findCat = checkGroups.find(g => g.name === groupName);

                if (!findCat) {
                    findCat = {
                        name: groupName,
                        id: d.merchantId,
                        isCollapsed: (merchantMapping.length > 20),
                        items: []
                    };
                    checkGroups.push(findCat);
                }
                //business without vgurl are invalid and only used as grouping
                if (d.vagaroURL && d.vagaroURL.length > 0)
                    findCat.items.push({
                        id: d.merchantId,
                        name: d.businessName,
                        checked: d.isSelected,
                        misc: d

                    });


                if (!findGroup) {
                    findGroup = {
                        groupName: groupName,
                        groupData: []
                    };
                    groups.push(findGroup);
                }
                //business without vgurl are invalid and only used as grouping
                if (d.vagaroURL && d.vagaroURL.length > 0)
                    findGroup.groupData.push(d);

            }


            groups.sort((a, b) => a.groupName.localeCompare(b.groupName));
            checkGroups.sort((a, b) => a.name.localeCompare(b.name));
            let total = 0;
            for (let i = 0; i < checkGroups.length; i++) {
                let group = checkGroups[i];
                group.items.sort((a, b) => a.name.localeCompare(b.name));
                total += group.items.length;
            }

            for (let i = 0; i < groups.length; i++) {
                let group = groups[i];
                group.groupData.sort((a, b) => a.businessName.localeCompare(b.businessName));

            }
            let numOfSelected = 0;
            for (let i = 0; i < checkGroups.length; i++) {
                numOfSelected += checkGroups[i].items.filter(item => item.checked).length;
            }
            setTotalNumOfLocations(total);
            setCatFilterItems(checkGroups);
            setLocationGroups(groups);
            setNumSelectedLocations(numOfSelected);
        }
        loadSuccessRef.current++;
        if (loadSuccessRef.current >= 2) {
            setIsStenciled(false);
        }

        setIsStenciled(false);
    }
    const getMultilocationFail = () => {
        setIsStenciled(false);
        utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
    }

    const onUpdateSelections = (cats: CheckCategory[]) => {

        for (let i = 0; i < cats.length; i++) { // toggle selections
            for (let j = 0; j < cats[i].items.length; j++) {
                if (cats[i].items[j].misc) {
                    cats[i].items[j].misc.isSelected = cats[i].items[j].checked;
                }
            }
        }
        let numOfSelected = 0;
        for (let i = 0; i < cats.length; i++) {
            numOfSelected += cats[i].items.filter(item => item.checked).length;
        }
        setNumSelectedLocations(numOfSelected);
        setCatFilterItems([...cats]);
        if (designer)
            designer.panelMenuLocked = true;



    }

    const multiLocationPlanSuccess = (data: any) => {

        if (data?.data?.data) {
            let plan = data.data.data;
            setPlanData(plan);

        }

        loadSuccessRef.current++;
        if (loadSuccessRef.current >= 2) {
            setIsStenciled(false);
        }
    }

    const GetMultilocation = async () => {
        let access_token = userContext.accessToken;
        if (utils.Validate(access_token)) {

            setIsStenciled(true);

            await AsyncAjaxGet(
                VagaroAPIURL.GetMultilocation,
                access_token,
                getMultiLocationSuccess,
                getMultilocationFail,
                userContext.businessId,
                userContext.encUserId
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };


    const GetMultilocationPlan = async () => {
        const access_token = userContext.accessToken;
        if (utils.Validate(access_token)) {
            setIsStenciled(true);
            await AsyncAjaxGet(
                VagaroAPIURL.GetMultilocationPlan,
                access_token,
                multiLocationPlanSuccess,
                () => {
                    setIsStenciled(false);
                },
                userContext.businessId,
                userContext.encUserId
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };

    useEffect(() => {
        GetMultilocation();
        GetMultilocationPlan();
    }, []);

    const SaveLocation = async () => {



        const access_token = userContext.accessToken;
        if (!IsModifyAllowed) {
            utils.ShowAlert("Alert", "You do not have access to save multilocations.", "OpenDialog");
        }
        else {
            // PopupType = Mode;
            if (utils.Validate(access_token)) {
                let selectedList = [];
                for (let i = 0; i < catFilterItems.length; i++) {
                    let filtered = catFilterItems[i].items.filter((item) => item.checked);
                    if (filtered.length > 0) {
                        selectedList.push(...filtered.map((item) => item.misc));
                    }
                }

              

                let paramList = selectedList.map((d) => {
                    let param: any = {};
                    param.strBusinessID = d.merchantId;
                    param.type = utils.Validate(d.urlType) ? d.urlType : 1;
                    param.URL = param.type == 1 ? d.urlAddress : d.urlName;
                    param.isPromoBusiness = d.isPromoBusiness;
                    return param;

                });
                setIsStenciled(true);
                await AsyncAjaxPost(
                    VagaroAPIURL.SaveMultilocation,
                    paramList,
                    access_token,
                    (data: any) => {

                        if (data?.data?.responseCode == ResponseCode.Success) {
                            setIsStenciled(false);
                            Toast("Multi-location has been saved successfully.");
                            dispatch(UpdateLocationCount(data.data.data));
                            onClose();
                        }
                        else {
                            setIsStenciled(false);
                            utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                        }
                    },
                    () => {
                        setIsStenciled(false);
                        utils.ShowAlert("Alert", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
                    },
                    userContext.businessId,
                    userContext.encUserId
                );
            }
            else {
                utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
            }
        }
    }

    const ChangeName = (data: MultiLocationData) => {

        if (!IsModifyAllowed) {
            utils.ShowAlert("Alert", "You do not have access to edit location.", "OpenDialog");
        }
        else {
            return ReactDOM.render(
                <ChangeNickName domainName={data.domain} vagaroURL={data.vagaroURL} onApply={(t: number) => {

                    let groups = [...locationGroups];
                    for (let i = 0; i < groups.length; i++) {
                        for (let j = 0; j < groups[i].groupData.length; j++) {
                            let d = groups[i].groupData[j];
                            d.urlType = t;
                            d.alias = t == 1 ? d.urlAddress : d.urlName;


                        }
                    }

                    setLocationGroups(groups);


                }}
                    mappingType={data.urlType} urlAddress={data.urlAddress} urlName={data.urlName} nickName={data.nickName}

                />,
                document.getElementById("OpenDialog") as HTMLElement)
        }
    }
    let filteredGroups = (filter.length > 2) ? locationGroups.map(group => {

        let newGroup = {
            groupName: group.groupName, groupData:
                group.groupData.filter(data => {

                    return data.businessName.toLowerCase().includes(filter) ||
                        data.stateName.toLowerCase().includes(filter) ||
                        data.street.toLowerCase().includes(filter) ||
                        data.city.toLowerCase().includes(filter) ||
                        ((userContext.vgurl ?? "") + data.alias).toLowerCase().includes(filter) ||
                        data.zip.toLowerCase().includes(filter)
                })

        };

        return newGroup;


    }).filter(g => g.groupData.length > 0) : locationGroups;

    if (isStencilded) {
        filteredGroups = [];
    }

    let planMessage = "";
    let contactLink = "https://www.vagaro.com/pro/contact-sales-team";
    if (CountryID == 1) {
        contactLink = "https://www.vagaro.com/pro/contact-sales-team";
    }
    else if (CountryID == 2) {
        contactLink = "https://www.vagaro.com/en-gb/pro/contact-sales-team";
    }
    else if (CountryID == 3) {
        contactLink = "https://www.vagaro.com/en-ca/pro/contact-sales-team";
    }
    else if (CountryID == 4) {
        contactLink = "https://www.vagaro.com/en-au/pro/contact-sales-team";
    }
    let plan = planData.find(p => p.fromPlan <= numSelectedLocations && p.toPlan >= numSelectedLocations);
    if (plan) {

        planMessage = `Monthly cost will be ${CurrencySymbol}${plan.charges}/mo `;
        if (plan.isContactSales) {



        }
    }
    let isLocationSelected = filteredGroups.some( item => item.groupData && item.groupData.find(Selection => Selection.isSelected));
    let locationString = `${numSelectedLocations} Location${numSelectedLocations != 1 ? "s" : ""}`;
    if (numSelectedLocations == totalNumOfLocations) {
        locationString = `All  Locations (${totalNumOfLocations})`;
    }
    else if (numSelectedLocations == 0) {

        locationString = `Select Business Locations`;
    }


    return <div className="w-full h-full"> <HeaderCTA />
        <br />
        <div className="multi-title">Active Locations</div>
        <label style={{ marginBottom: "0", fontWeight: "500" }} className="form-label">Select Locations:</label>
        <div className={isStencilded ? "stenciled w-full flex-row gap-large" : "w-full flex-row gap-large"}>
            <CategorySelectorWrapper onUpdate={onUpdateSelections} categories={catFilterItems} >
                <div className="w-full flex-row justify-between" style={{ borderRadius: "4px", padding: "8px", border: "1px solid var(--bs-border-color)", cursor: "pointer" }} >
                    <span>
                        {locationString}
                    </span>
                    <DownCaret />
                </div>
            </CategorySelectorWrapper>
            <div className="w-full">
                {plan?.isContactSales ?
                    <a className="calculate-link-new" href={contactLink} target="_blank">Contact Sales</a> :
                    <div className="calculate-link-new" onClick={() => {
                        OpenCharges(CurrencySymbol, planData, contactLink);
                    }}>{planMessage}</div>
                }
            </div>
        </div>

        {numSelectedLocations > 20 && <>

            <div className="relative w-full" style={{ paddingTop: "8px" }}>
                <div style={{ position: "absolute", top: "2px" }}><SearchIcon /></div>
                <input style={{ paddingLeft: "40px" }} type="text" className="form-control search-input" placeholder="Search by business name, address or URL" value={filter} onChange={(e) => setFilter(e.target.value.toLowerCase())} /></div>
        </>
        }

        <div className="multilocation-table" >
            <div className="multi-table table w-full">

                <TableHeader />
                {isStencilded && <TableStencilRows rowCount={1} />}
                {filteredGroups.map((group, index) => {
                    if (group.groupData.length == 0)
                        return null;

                    return <LocationGroup onEdit={ChangeName} prefix={userContext.vgurl ?? ""} key={index} group={group} startExpanded={index == 0 && locationGroups.length <= 8} />
                })

                }
                {!isLocationSelected && !isStencilded && <div className="w-full " style={{ padding: "8px" }}>No locations found.</div>}

            </div>
        </div>

        <div className="page-title title-with-actions" style={{ position: "sticky", bottom: "0", background: "#fff" }}>
            <div className="inline-actions-btns">
                <button onClick={onCancel} className="w-button w-button-secondary">Cancel</button>
                <button className="w-button w-button-primary close-on-click"
                    onClick={SaveLocation}
                >Save</button>
            </div>
        </div>
    </div>
}

function TableHeader() {

    return <div className="tr flex-row "><div className="th img-column">Business Name</div><div className="th link-column" >URL</div><div className="th address-column">Address</div></div>

}
//open charges popup.
const OpenCharges = (CurrencySymbol: string, locationPlan: PlanBracket[], link: string) => {

    const CancelPopup = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog") as HTMLElement);
    };
    return ReactDOM.render(
        <VGPopUp
            show={true}
            onHide={CancelPopup}
            title="Tiered Pricing"
            body={
                <Fragment>
                    <div className="alertContent">
                        <p>The pricing is calculated based on how many locations are included in your MySite. </p>
                    </div>
                    <div className="multilocation-table h-full">
                        <table className="multi-table">
                            <thead>
                                <tr>
                                    <th className="row-33-percentage">Tier</th>
                                    <th className="row-33-percentage">Number of Locations</th>
                                    <th className="row-33-percentage">Price ({CurrencySymbol}/mo)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Fragment>
                                    {locationPlan.map((data, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="row-33-percentage">Tier {index + 1}</td>
                                                <td className="row-33-percentage">{data.fromPlan == data.toPlan ? data.fromPlan : (data.fromPlan + (utils.Validate(data.toPlan) && data.toPlan < 32767 ? ("-" + data.toPlan) : "+"))}</td>
                                                <td className="row-33-percentage">{data.isContactSales ? <a href={link} target="_blank" style={{ textDecoration: "none" }}> Contact Sales </a> : CurrencySymbol + data.charges} </td>
                                            </tr>
                                        )
                                    })}
                                </Fragment>
                            </tbody>
                        </table>
                    </div>
                </Fragment>
            }
            footer={
                <button
                    className="w-button w-button-secondary"
                    type="button"
                    onClick={CancelPopup}
                >
                    Close
                </button>
            }
            isShowFooter={true}
        />,
        document.getElementById("OpenDialog")
    );
};

function LocationGroup({ group, startExpanded, prefix, onEdit }: { onEdit: (data: MultiLocationData) => void, prefix: string, group: MultiLocationGroup, startExpanded?: boolean }) {

    const [isExpanded, setIsExpanded] = useState<boolean>((!group.groupName || group.groupName.length <= 0) ? true : startExpanded || false);

    const [top, setTop] = useState<number>(0);
    const divRef = useRef<HTMLDivElement>(null);
    const filtered = group.groupData.filter(g => g.isSelected);
    const handleScroll = () => {
        if (divRef.current) {
            // Get the position of the group header relative to the viewport
            let rect = divRef.current.getBoundingClientRect();
            setTop(rect.bottom);

        }


    }

    useEffect(() => {
        let pannel = document.getElementById("left-flyout");
        let resizeObserver = new ResizeObserver(() => {
            window.requestAnimationFrame(() => {
                handleScroll();
            });
        });
        if (divRef.current) { // when expanding other groups the top position needs to be updated again
            let table = divRef.current.parentElement;
            if (table) {
                resizeObserver.observe(table);
            }

        }
        if (pannel) {
            pannel.addEventListener("scroll", handleScroll);

        }

        return () => {
            if (pannel) {
                pannel.removeEventListener("scroll", handleScroll);
            }
            resizeObserver.disconnect();
        }


    }, [])

    useEffect(() => {

        handleScroll(); // Update top when isExpanded changes
    }, [isExpanded]);

    if (filtered.length == 0) {
        return null; // Don't render if no locations are selected in this group
    }

    return <>
        {
            group.groupName && group.groupName.length > 0 &&
            <div className="tr flex-row" ref={divRef}  >
                <div style={{ cursor: "pointer" }} className="group-header td w-full" onClick={() => setIsExpanded(!isExpanded)}>
                    <div className="group-name flex-row gap-med">
                        <div style={{ fontSize: "1.2em", transition: ".2s", transform: (isExpanded ? "rotateZ(90deg)" : "rotateZ(0deg)") }}> <RightCaret /></div>
                        <span>{group.groupName}</span>

                    </div>
                </div>
            </div>
        }
        {isExpanded && <div className="w-full relative vanimation-fade-in no-delay" style={{ height: (filtered.length * 100 + "px") }}>{filtered.map((data, index) => {

            let position = (index * 100) + top;
            if (position < -100 || position > window.innerHeight + 100) {
                return null;
            }


            return <TableRow
                data={data}
                onEdit={onEdit}
                index={index}
                key={index + data.businessName}
                img={data.cdn}
                title={data.businessName}
                url={prefix + "/" + data.alias} address={`${data.street}, ${data.city}, ${data.stateName}, ${data.zip}`} />
        })
        }</div>
        }
    </>


}

function TableRow({ img, title, address, url, index, onEdit, data }: { data: MultiLocationData, onEdit: (data: MultiLocationData) => void, index: number, img: string, title: string, url: string, address: string }) {


    return <div className="expanded-row tr w-full "
        style={{ position: "absolute", top: `${index * 100}px`, left: "0" }}
    >
        <div className="img-column  td">
            <div className="business-details">
                <div className="busi-profile">
                    <img loading="lazy" src={img} width="60px" height="40px" />
                </div>
                <div className="busi-decs">{title}</div>
            </div>
        </div>
        <div className="link-column td">
            <span >{url}</span>
        </div>

        <div className="edit-column td relative">
            <a className="tab-link" onClick={(e) => {
                e.preventDefault();
                onEdit(data);
            }} >
                <svg width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="currentColor"><path d="M1.7915 12.2812C1.9165 11.8438 2.1665 11.4375 2.479 11.125L11.979 1.625C12.7603 0.84375 14.0415 0.84375 14.8228 1.625L16.0415 2.84375C16.1353 2.9375 16.229 3.0625 16.2915 3.15625C16.8228 3.9375 16.729 5 16.0415 5.6875L6.5415 15.1875C6.51025 15.2188 6.44775 15.25 6.4165 15.3125C6.104 15.5625 5.76025 15.75 5.38525 15.875L1.604 16.9688C1.354 17.0625 1.07275 17 0.885254 16.7812C0.666504 16.5938 0.604004 16.3125 0.666504 16.0625L1.7915 12.2812ZM2.51025 15.1562L4.94775 14.4375C5.01025 14.4062 5.104 14.375 5.1665 14.3438L4.0415 14.125C3.7915 14.0625 3.57275 13.875 3.5415 13.625L3.32275 12.5C3.2915 12.5625 3.26025 12.6562 3.229 12.7188L2.51025 15.1562ZM6.2915 13.3125L12.6353 6.96875L10.6665 5.03125L4.354 11.375L4.6665 12.9688L6.2915 13.3125Z"></path></svg>
            </a>
        </div>
        <div className="address-column td">{address}</div>
    </div>

}

function HeaderCTA() {
    return <Form.Group className={`form-row`}>
        <div className="multilocation-banner">
            <div className="multi-bnr-decs">
                <h2>Multi-Location</h2>
                <p>Design your website once for one location and then enable this feature to automatically duplicate pages for selected locations of your business within minutes.</p>
            </div>
            <div className="multi-images">
                <img src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/multilocation-banner-img.png" alt=""></img>
            </div>
        </div>
    </Form.Group>
}
function TableStencilRows({ rowCount }: { rowCount: number }) {

    const style = {
        height: "94px",
        overflow: "hidden",

        opacity: 1
    }

    const rows = Array.from({ length: rowCount }, (_, index) => index);

    return <div className="stenciled  flex-column gap-small w-full">
        {rows.map((item: any, index: number) => {
            return <div key={index} className='w-full stencil-item' style={style}>Loading Location Data</div>

        })}

    </div>

}

function CategorySelectorWrapper({ categories, children, onUpdate }: { categories: CheckCategory[], children?: any, onUpdate: (cats: CheckCategory[]) => void }) {

    const [isOpen, setIsOpen] = useState<boolean>(false);


    const clickOutsideRef = useRef<HTMLDivElement>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (clickOutsideRef.current && !clickOutsideRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return <div ref={clickOutsideRef} className="relative stencil-item w-full" onClick={(e) => {

        setIsOpen(true);
    }}>{children}
        {isOpen && <div className="w-full " style={{ background: "white", position: "absolute", left: "0", top: "100%", overflow: "auto", minWidth: "390px", maxHeight: "350px", zIndex: "5", boxShadow: "0 2px 5px 3px #00000022", borderRadius: "4px" }} >
            <CategorySelector useAmbiguous={true} sticky={true} catagories={categories} onUpdate={onUpdate} />

        </div>}
    </div>



}

const ChangeNickName = ({ mappingType, urlAddress, urlName, nickName, onApply, vagaroURL, domainName }: { domainName: string, vagaroURL: string, onApply: (val: number) => void, mappingType: number, urlAddress: string, urlName: string, nickName: string }) => {

    //Only 2 State Allow
    const [selctedValue, setSelectedValue] = useState(mappingType);
    const [url, setURL] = useState(mappingType == 1 ? urlAddress : (mappingType == 2 ? urlName : ((mappingType == 3 ? nickName : ""))));

    const ChangeBusinessType = (event: any) => {
        if (event.target.value == 1) {
            setURL(urlAddress);
        }
        else if (event.target.value == 2) {
            setURL(urlName);
        }
        else if (event.target.value == 3) {
            setURL(nickName);
        }
        setSelectedValue(event.target.value);
    }


    const ApplyChanges = () => {
        try {
            PopupClose();
            onApply(selctedValue);
        } catch (error) {

        }
    }

    const EditStyleBody = () => {
        return (
            <div>
                <div className="form-content" style={{ marginBottom: "10px" }}>
                    Edit your multi-location URL.
                </div >
                <div className="form-content">
                    <div className="form-row" style={{ marginBottom: "10px" }}>
                        <label className="form-label">URL Type:</label>
                        <div className="vg-wb-select">
                            <select className="form-control" defaultValue={selctedValue} onChange={(e) => ChangeBusinessType(e)}>
                                <option value={1} >Address</option>
                                <option value={2} >Business Name</option>
                            </select>
                        </div>
                        <div className="allurl">This will apply to all URLs.</div>
                    </div>

                    <div className="form-row">
                        <label className="form-label">Updated URL:</label>
                        <label className="form-label mysite-url">{utils.MySiteName().replace("https://", "") + '/' + vagaroURL + '/' + url}</label>
                        {domainName != "" &&
                            <label className="form-label mysite-url">{domainName.replace("https://", "") + '/' + url}</label>
                        }

                    </div>


                </div>
            </div>

        )
    }

    const EditStyleFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()}>Cancel</button>
                <button className="w-button w-button-primary" onClick={() => ApplyChanges()}>Save</button>
            </Fragment>
        )
    }

    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog") as HTMLElement);
    };
    return createPortal(
        <Fragment>
            <VGPopUp
                id={"ChangeNickName"}
                show={true}
                title={"Edit URL"}
                onHide={PopupClose}
                size="sm"
                body={EditStyleBody()}
                dialogClassName="vg-w480"
                footer={EditStyleFooter()}
                isShowFooter={true}
                backdrop={true}
                isRemoveTabModalIndex={true}
            />
        </Fragment>,
        document.getElementById("OpenDialog") as HTMLElement
    )
}
